import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modeVou';
const args = {};

export class ModeVou extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
